var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unauthorized"},[_c('h1',[_vm._v("Unauthorized Access")]),_c('p',[_vm._v(" You do not have permission to view this page. You will be redirected to the home page in "+_vm._s(_vm.counter)+" second"),(_vm.counter !== 1)?_c('span',[_vm._v("s")]):_vm._e(),_vm._v(". ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }